export const baseSortTypes = {
  asc: 'asc',
  desc: 'desc',
  null: null
} as const;

export type BaseSortType = (typeof baseSortTypes)[keyof typeof baseSortTypes];

/**
 * A column's sort state. `TColumn` is the set of values the server accepts in
 * its `ordering` query parameter; it defaults to `string` so untyped tables
 * keep compiling. Type it (see `OrderingKeyOf` in noddi-async) and a column
 * the endpoint cannot sort on fails `tsc` instead of 400-ing at runtime.
 */
export interface BaseSortState<TColumn extends string = string> {
  column: TColumn;
  order: BaseSortType;
}
